import { render, staticRenderFns } from "./LandingBaseView.vue?vue&type=template&id=4a649858"
import script from "./LandingBaseView.vue?vue&type=script&lang=ts"
export * from "./LandingBaseView.vue?vue&type=script&lang=ts"
import style0 from "./LandingBaseView.vue?vue&type=style&index=0&id=4a649858&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports